module.exports = __webpack_public_path__ + "img/firSub3.baf5050a.png";